import { Center, Box, Text, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Center h="400px">
        <Box textAlign="center">
          <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
            Page Not Found
          </Text>
          <Text fontSize="sm" color="gray.500" mb={4}>
            The page you're looking for doesn't exist.
          </Text>
          <Button
            size="sm"
            bg="var(--brand-primary)"
            color="white"
            _hover={{ bg: 'var(--brand-primary-hover)' }}
            onClick={() => navigate('/dashboard')}
          >
            Back to Dashboard
          </Button>
        </Box>
      </Center>
    </>
  );
}
